<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { CriteriaFromStringBuilderViewModel } from "@Criteria/Hierarchies/Components/CriteriaFromStringBuilder";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class CriteriaFromStringBuilder extends Vue
    {
        get vm(): CriteriaFromStringBuilderViewModel { return this.$props.viewModel as CriteriaFromStringBuilderViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }

        get parentName(): string { return this.vm.parentName; }
        
        criteriaString: string | null = null;

        handleFormSubmit()
        {
            this.$emit('create-criteria', this.vm.parentId, this.criteriaString);
            this.criteriaString = null;
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Add criteria under: {{ parentName }}</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">

                        <form id="criteria-from-string-builder-form" @submit.prevent="handleFormSubmit">
                            <div class="form-group">
                                <label>Enter criteria below, each on a new line:</label>
                                <textarea v-model.trim="criteriaString" class="form-control" rows="8" required></textarea>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-outline-secondary">Close</button>
                        <button type="submit" form="criteria-from-string-builder-form" class="btn btn-primary">Create</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>